import { useTitle } from "@/hooks/use-title.hook.ts";
import analyticsService, {
  analyticEvents,
  analyticProperties,
} from "@/services/analytics-service.ts";
import { LinkTo, Page, Stack, Text, Title } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export default function EmailConfirmed() {
  const { t } = useTranslation();
  useTitle(t("core:welcome_after_email_confirm_title"));
  return (
    <>
      <Page>
        <Page.Content>
          <Stack className={"container-sm mx-auto py-16"}>
            <Title
              header={t("core:welcome_after_email_confirm_title")}
              size={"lg"}
              paddingBottom
              paddingTop
            />
            <Title
              header={t("core:welcome_after_email_confirm_title_2")}
              size={"md"}
              paddingBottom
              paddingTop
            />
            <Text>{t("core:welcome_after_email_confirm_description")}</Text>
            <Title
              header={t("core:welcome_after_email_confirm_whats_next")}
              size={"md"}
              paddingTop
            />
            <Title
              header={t("core:welcome_after_email_confirm_invite_your_team")}
              size={"sm"}
              paddingBottom
              paddingTop
            />
            <Text>
              {t("core:welcome_after_email_confirm_invite_your_team_description")}{" "}
              <LinkTo to={"/employees"}>
                {t("core:welcome_after_email_confirm_invite_your_team_button")}
              </LinkTo>
            </Text>
            <Title
              header={t("core:welcome_after_email_confirm_install_chrome")}
              size={"sm"}
              paddingBottom
              paddingTop
            />
            <Text>
              {t("core:welcome_after_email_confirm_install_chrome_description")}{" "}
              <LinkTo
                onClick={() => {
                  analyticsService.trackEvent(analyticEvents.pageAction, {
                    [analyticProperties.actionType]: "Extension Clicked",
                    [analyticProperties.source]: "Email Confirmed",
                  });
                }}
                target={"_blank"}
                to={import.meta.env.VITE_EXTENSION_URL}
              >
                {t("core:welcome_after_email_confirm_install_chrome_button")}
              </LinkTo>
            </Text>
          </Stack>
        </Page.Content>
      </Page>
    </>
  );
}
